import React from 'react';
import { Dimensions, Image, PixelRatio, StyleSheet, TouchableOpacity, View, ImageSourcePropType } from 'react-native';
import Svg, { Path } from "react-native-svg";
import ImageClass from '../../shell/Image';
import { isMobile } from '../../shell/utils/platformCheck';
import { InstaImage } from './interfaces';
import Icon from 'react-native-vector-icons/FontAwesome';
import useFontSize from '../../shell/hooks/useFontSize';



interface InstaImagesProps {
    images: InstaImage[],
    onImagePressed: (image: InstaImage) => void;
}

export const InstaImages: React.FC<InstaImagesProps> = ({ images, onImagePressed }) => {


    const styles = StyleSheet.create({

        imagesContainer: {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",


        },
        imageWrapper: {
            flexBasis: "33.3333%",
            overflow: "hidden",
        },
        image: {
            margin: 5,
            aspectRatio: isMobile() ? undefined : 16 / 9,
            resizeMode: 'cover',
            height: Dimensions.get("window").height / 3,
            width: undefined,
            flex: 1,
            borderColor: "#73737378",
            borderRadius: 2,
            borderWidth: 5,


        },

    });
    function foldersIcon() {
        return (
            <Svg
                width={22}
                height={22}
                fill="#fff"
                color="#fff"
                viewBox="0 0 48 48"
                style={{
                    position: "absolute",
                    right: "2.5%",
                    top: "5%",
                }}

            >
                <Path d="M34.8 29.7V11c0-2.9-2.3-5.2-5.2-5.2H11c-2.9 0-5.2 2.3-5.2 5.2v18.7c0 2.9 2.3 5.2 5.2 5.2h18.7c2.8-.1 5.1-2.4 5.1-5.2zM39.2 15v16.1c0 4.5-3.7 8.2-8.2 8.2H14.9c-.6 0-.9.7-.5 1.1 1 1.1 2.4 1.8 4.1 1.8h13.4c5.7 0 10.3-4.6 10.3-10.3V18.5c0-1.6-.7-3.1-1.8-4.1-.5-.4-1.2 0-1.2.6z" />
            </Svg>
        );
    }
    return (
        <>

            <View style={styles.imagesContainer}>

                {images.map((image, i) => (

                    <TouchableOpacity onPress={() => onImagePressed(image)} key={i} style={styles.imageWrapper}>

                        <Icon selectable={false} name={"heart"} size={useFontSize(2)} style={{ zIndex: 200, position: "absolute", opacity: image.mcLiked?1:0, right: 0, bottom: 0, padding: 15 }} color={"#bb1515"} />
                        <Image source={(ImageClass._globalImages.get(image.image?.key)?.url) || image.image as ImageSourcePropType} style={[styles.image, i % 1 === 0 ? {} : {}]} />

                        {image.image.partials ? foldersIcon() : <></>}

                    </TouchableOpacity>
                ))}

            </View>


        </>
    );
};